import { createContext, useContext } from 'react';

/** The dashboard's address, provided once by `main.tsx` from the page's initial data. */
export const SiteLinksContext = createContext<string | null>(null);

/**
 * Where "Get started" goes: the dashboard's address, from the settings naru-server delivers with the landing page.
 *
 * @returns The address `main.tsx` provided.
 * @throws Error when called outside a `SiteLinksContext` provider.
 */
export function useDashboardAppUrl(): string {
  const dashboardAppUrl = useContext(SiteLinksContext);

  if (dashboardAppUrl === null) {
    throw new Error('useDashboardAppUrl must be used inside a SiteLinksContext provider');
  }

  return dashboardAppUrl;
}
